import { HighlightText } from '@cancercentrum/rcc-react';
import type { HierarchifiedSubstansItem, Icd10VDItem, RegimItem, UtvaldSubstansVDItem } from '../types.ts';

export const regimFormatter = (item: RegimItem) => item.data.reg_namn;
export const substansFormatter = (item: HierarchifiedSubstansItem | UtvaldSubstansVDItem) => item.text;
export const icd10FormatterText = (item: Icd10VDItem) => `${item.data.kod} ${item.data.beskrivning}`;
export const icd10Formatter = (item: Icd10VDItem, filter: string) => <HighlightText text={`${item.data.kod} ${item.data.beskrivning}`} search={filter} />;
